import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Col, Row } from 'reactstrap';

/**
 * This returns the maintenance banner displayed to the user on the auction/sales calendar
 *
 * @param {Object} MaintenanceAlert The JSON object containing the following params:
 * @param {function} MaintenanceAlert.hideMaintenanceBanner The action to dismiss the banner
 * @param {string} MaintenanceAlert.maintenanceWindowString The string containing the
 *  date of maintenance
 * @param {boolean} MaintenanceAlert.showMaintenanceAlert The boolean to determine to show the alert
 */
const MaintenanceAlert = ({
  hideMaintenanceBanner,
  maintenanceWindowString,
  showMaintenanceAlert
}) => (
  <Alert
    color="warning"
    className="mb-3"
    isOpen={showMaintenanceAlert}
    toggle={hideMaintenanceBanner}
  >
    <Row>
      <Col xs={1} className="py-2 text-center">
        <FontAwesomeIcon icon="exclamation-circle" size="2x" />
      </Col>
      <Col xs={10}>
        Due to scheduled maintenance, all{' '}
        <strong>Invaluable and AuctionZip websites and website properties</strong> will be{' '}
        unavailable from <strong>{maintenanceWindowString}</strong> We will be unable to schedule or
        run any auctions shortly before or during these times. We apologize for any inconvenience.{' '}
        Please be aware of this time frame when posting auctions on and around this date.
      </Col>
    </Row>
  </Alert>
);

export default MaintenanceAlert;
